<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="single_cv_instantiated"
    :start_opened="single_cv_instantiated"
  >
    <!-- {{ caruana_single_cv }} -->
    <div v-if="single_cv_instantiated">
      <div v-if="!_.isEmpty(caruana_single_cv)">
        <performances-chart-caruana
          key="single_cv_caruana_chart"
          :project_id="project_id"
          :is_caruana="true"
          :is_cv="true"
          :is_single_cv="true"
          :tracking_infos="caruana_single_cv"
          :nb_iters="nb_single_cv_iters"
        />
        <performances-table-caruana
          key="single_cv_caruana_table"
          :project_id="project_id"
          :is_caruana="true"
          :is_cv="true"
          :is_single_cv="true"
          :tracking_infos="caruana_single_cv"
          :models="models"
        />
      </div>
      <div v-else>
        <performances-chart-caruana
          key="single_cv_simple_chart"
          :project_id="project_id"
          :is_caruana="false"
          :is_cv="true"
          :is_single_cv="true"
          :tracking_infos="tracking_single_cv"
          :nb_iters="nb_single_cv_iters"
        />

        <performances-table-caruana
          key="single_cv_simple_table"
          :project_id="project_id"
          :is_caruana="false"
          :is_cv="true"
          :is_single_cv="true"
          :tracking_infos="tracking_single_cv"
          :model_name="models[0]"
        />
      </div>
    </div>
  </unroll-element>
</template>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'
import PerformancesChartCaruana from './performances_chart_caruana.vue'
import PerformancesTableCaruana from './performances_table_caruana.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentSingleCv',
  components: {
    UnrollElement,
    PerformancesChartCaruana,
    PerformancesTableCaruana,
  },

  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid', 'nb_single_cv_iters'],

  computed: {
    _() {
      return _
    },
    // caruana_single_cv() {
    //   let res = {}
    //   _.forEach(
    //     _.entries(this.caruana_model_searches || {}),
    //     ([name, info]) => {
    //       res[name] = this.fetch_poid_tracking_info(
    //         `caruana_single_cv_${name}_${info}`,
    //         (info || {}).single_cv
    //       )
    //     }
    //   )
    //   return res
    // },
    caruana_single_cv() {
      let entries = _.entries(this.caruana_model_searches)

      let category_and_arguments_list = _.map(entries, ([key, value]) => {
        return ['poid_tracking_info', (value || {}).single_cv]
      })

      let fetched = this.fetch_many(
        'caruana_single_cv',
        category_and_arguments_list
      )
      let res = _.fromPairs(_.zip(_.keys(this.caruana_model_searches), fetched))
      return res
    },

    tracking_single_cv() {
      let res = (this.model_tracking_info || {}).single_cv
      return res
    },

    single_cv_instantiated() {
      let res =
        !_.isEmpty(this.caruana_single_cv) ||
        !_.isUndefined(this.tracking_single_cv)

      return res
    },
  },

  watch: {
    single_cv_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
